/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserAdminRequest } from '../models/CreateUserAdminRequest';
import type { GetCurrentUserClientResponse } from '../models/GetCurrentUserClientResponse';
import type { GetUserOrderSummaryResponse } from '../models/GetUserOrderSummaryResponse';
import type { GetUserRolesClientResponse } from '../models/GetUserRolesClientResponse';
import type { GetUserRolesOperatorResponse } from '../models/GetUserRolesOperatorResponse';
import type { GetUserRolesResponse } from '../models/GetUserRolesResponse';
import type { GetUsersByIdsResponseAdmin } from '../models/GetUsersByIdsResponseAdmin';
import type { GetUsersCountResponseAdmin } from '../models/GetUsersCountResponseAdmin';
import type { Pagination1OfUserListedDto } from '../models/Pagination1OfUserListedDto';
import type { PutUserRolesRequestAdmin } from '../models/PutUserRolesRequestAdmin';
import type { PutUserVipRequestAdmin } from '../models/PutUserVipRequestAdmin';
import type { UpdateUserAdminRequest } from '../models/UpdateUserAdminRequest';
import type { UserDto } from '../models/UserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * @returns GetUserRolesOperatorResponse OK
     * @throws ApiError
     */
    public static getCurrentUserRolesOperator(): CancelablePromise<GetUserRolesOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/users/current/roles',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns UserDto OK
     * @throws ApiError
     */
    public static getUserOperator(): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/users/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns UserDto OK
     * @throws ApiError
     */
    public static getUserDriver(): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/users/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetUserRolesResponse OK
     * @throws ApiError
     */
    public static getCurrentUserRolesDriver(): CancelablePromise<GetUserRolesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/users/current/roles',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetUserRolesClientResponse OK
     * @throws ApiError
     */
    public static getCurrentUserRolesClient(): CancelablePromise<GetUserRolesClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/users/current/roles',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetCurrentUserClientResponse OK
     * @throws ApiError
     */
    public static getUserClient(): CancelablePromise<GetCurrentUserClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/users/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns UserDto OK
     * @throws ApiError
     */
    public static getCurrentUserAdmin(): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetUserRolesResponse OK
     * @throws ApiError
     */
    public static getCurrentUserRolesAdmin(): CancelablePromise<GetUserRolesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/current/roles',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUsers`
     * @returns UserDto OK
     * @throws ApiError
     */
    public static getUserAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUsers`
     * @returns GetUserOrderSummaryResponse OK
     * @throws ApiError
     */
    public static getUserOrderSummaryAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetUserOrderSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/{id}/order-summary',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUserRoles`
     * @returns GetUserRolesResponse OK
     * @throws ApiError
     */
    public static getUserRolesAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetUserRolesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/{id}/roles',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUserRoles`
     * @returns GetUserRolesResponse OK
     * @throws ApiError
     */
    public static putUserRolesAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutUserRolesRequestAdmin,
    }): CancelablePromise<GetUserRolesResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/users/{id}/roles',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUsers`
     * @returns Pagination1OfUserListedDto OK
     * @throws ApiError
     */
    public static getUsersAdmin({
        searchWord,
        id,
        regionId,
        roleId,
        baseRoleId,
        hasOrder,
        birthDateFrom,
        birthDateTo,
        createdAtFrom,
        createdAtTo,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        id?: string,
        regionId?: number,
        roleId?: number,
        baseRoleId?: number,
        hasOrder?: boolean,
        birthDateFrom?: string,
        birthDateTo?: string,
        createdAtFrom?: string,
        createdAtTo?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfUserListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users',
            query: {
                'searchWord': searchWord,
                'id': id,
                'regionId': regionId,
                'roleId': roleId,
                'baseRoleId': baseRoleId,
                'hasOrder': hasOrder,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUsers`
     * @returns GetUsersByIdsResponseAdmin OK
     * @throws ApiError
     */
    public static getUsersByIdsAdmin({
        userIds,
    }: {
        userIds?: Array<string>,
    }): CancelablePromise<GetUsersByIdsResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/by-ids',
            query: {
                'userIds': userIds,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUsers`
     * @returns GetUsersCountResponseAdmin OK
     * @throws ApiError
     */
    public static getUsersCountAdmin({
        searchWord,
        id,
        regionId,
        roleId,
        baseRoleId,
        hasOrder,
        birthDateFrom,
        birthDateTo,
        createdAtFrom,
        createdAtTo,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        id?: string,
        regionId?: number,
        roleId?: number,
        baseRoleId?: number,
        hasOrder?: boolean,
        birthDateFrom?: string,
        birthDateTo?: string,
        createdAtFrom?: string,
        createdAtTo?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<GetUsersCountResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/users/count',
            query: {
                'searchWord': searchWord,
                'id': id,
                'regionId': regionId,
                'roleId': roleId,
                'baseRoleId': baseRoleId,
                'hasOrder': hasOrder,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUsers`
     * @returns UserDto OK
     * @throws ApiError
     */
    public static postUserRequestCreationAdmin({
        requestBody,
    }: {
        requestBody?: CreateUserAdminRequest,
    }): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/users/send-create-user-request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUsers`
     * @returns UserDto OK
     * @throws ApiError
     */
    public static postUserRequestUpdateAdmin({
        userId,
        requestBody,
    }: {
        userId: string,
        requestBody?: UpdateUserAdminRequest,
    }): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/users/{userId}/send-update-user-request',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUserVip`
     * @returns any OK
     * @throws ApiError
     */
    public static putUserVipAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutUserVipRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/users/{id}/vip',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
